export const CONFIGURACION_CONTENT = {
    lessons: {
        // config.planes — «Planes y precios (listas con vigencia)» — roles: admin (Administración), owner (Dueño) — pantalla: "planes.catalogo" — práctica: sí
        "config.planes": {
            summary: "Aprendés cómo se arma el catálogo único de planes (qué incluye cada uno y a qué locales le abre la puerta) y cómo se carga cada aumento como una versión nueva de la lista de precios, con vigencia el día 1 de un mes. Ves el borrador, la publicación con alerta al Dueño y el historial de aumentos, y por qué una lista publicada no se edita.",
            keyPoints: [
                "El catálogo es uno solo para las tres sedes: no hay precios distintos por sede.",
                "El plan define qué incluye (tipo, cuotas, reglas comerciales, cobertura de acceso); los importes van en la lista de precios, nunca en el plan.",
                "«No está en lista» no es gratis: con ese medio no se puede cobrar ese plan. Y un tope semanal vacío es sin tope, no cero ingresos.",
                "Un aumento es una versión nueva de la lista con vigencia el día 1 de un mes: arranca con los importes vigentes, se puede guardar como borrador y se publica.",
                "Publicar le manda al Dueño la alerta de seguridad en el momento y queda en la auditoría. Una lista publicada no se edita: se carga otra versión.",
                "Un plan no se borra: se da de baja y las membresías vigentes siguen hasta su vencimiento. Sin lista vigente, el sistema no inventa un precio y los cobros se frenan.",
            ],
            estimatedMin: 10,
            contentVersion: 2,
        },
        // config.promociones — «Promociones» — roles: admin (Administración), owner (Dueño) — pantalla: "planes.promociones" — práctica: no
        "config.promociones": {
            summary: "Aprendés cómo el Dueño y Administración arman las promociones que después recepción sólo elige al cobrar: tipo y valor, vigencia, cupo y planes alcanzados. Ves cómo desactivar una promo con motivo sin borrarla y cómo leer el reporte de uso por sede, que sale de los cobros reales.",
            keyPoints: [
                "Las promos las crean el Dueño y Administración. Recepción no inventa descuentos: elige una promo vigente al cobrar y cada pago guarda cuál aplicó.",
                "Sólo las promos vigentes se pueden aplicar al cobrar; arriba filtrás vigentes, programadas, vencidas, desactivadas o todas.",
                "Tipos: descuento porcentual, monto fijo, precio especial o días bonificados. Cupo vacío es sin cupo, no cupo cero; sin planes marcados, alcanza a todos.",
                "Desactivar pide un motivo escrito y no borra: recepción deja de poder aplicarla en el acto y los pagos que ya la usaron le siguen apuntando.",
                "El tipo y el valor de una promo creada no se editan: si necesitás otro descuento, creás otra promoción. El cupo se respeta aunque dos cajas cobren a la vez.",
                "El reporte de uso sale de los cobros reales, por período y sede: un pago revertido no cuenta como uso.",
            ],
            estimatedMin: 7,
            contentVersion: 2,
        },
        // config.textos-legales — «Textos legales» — roles: admin (Administración), owner (Dueño) — pantalla: "socios.textos-legales" — práctica: no
        "config.textos-legales": {
            summary: "Aprendés a publicar versiones nuevas de los textos que firma el socio: el reglamento, la cesión de imagen, el retiro de menores, la autorización de débito y la declaración de condición física. Entendés por qué cada firma conserva la versión que firmó y cómo se pide la re-aceptación en la app sin bloquear el ingreso.",
            keyPoints: [
                "Cada documento tiene su tarjeta con la versión vigente, desde cuándo rige y todas las anteriores; con Ver el texto leés exactamente lo que se firmó en cada una.",
                "Para cambiar un texto se publica una versión nueva con el texto completo. Si Rige desde queda vacío, rige desde hoy, y el número de versión lo pone el sistema.",
                "Publicar no cambia ninguna firma vieja: cada firma guarda su versión, la fecha, quién firmó y el medio.",
                "Si el cambio es importante, se pide re-aceptación: la app se la pide al socio en el próximo uso, pero no le bloquea el ingreso.",
                "Una versión nueva no puede regir antes que la anterior, y un documento «Sin versiones» todavía no se puede mandar a firmar.",
                "Publican el Dueño y Administración; para los demás, el botón aparece deshabilitado.",
            ],
            estimatedMin: 6,
            contentVersion: 2,
        },
        // config.sedes-salones — «Sedes, locales y salones» — roles: branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "config.sedes" — práctica: no
        "config.sedes-salones": {
            summary: "Aprendés la diferencia entre sede (recepción, caja, stock y grilla) y local (espacio físico), qué es la sede virtual Central y dónde se ve con qué emisor y punto de venta factura cada sede. Ves los salones con su capacidad por disciplina y cómo reimprimir el QR de un salón, que nunca cambia.",
            keyPoints: [
                "Sede es la unidad con recepción, caja, stock y grilla; local es el espacio físico. Una sede puede tener más de un local, y cada local dice si tiene recepción.",
                "La plata y el stock se imputan a la sede; las clases y los molinetes, al local.",
                "La sede Central es virtual: no tiene locales ni opera, y junta los gastos comunes del club para repartirlos después entre las sedes.",
                "En Facturación ARCA ves el emisor y el punto de venta de cada sede. Con emisores fiscales cargados se cambia desde Emisores fiscales; si no, el punto de venta lo edita sólo el Dueño.",
                "Cada salón tiene su capacidad por disciplina, y ese número es el techo del cupo de cada clase.",
                "El QR del salón nace con la sala y no cambia: si el cartel se rompe, se reimprime. El que se regenera es el QR del local, desde Puntos de acceso.",
            ],
            estimatedMin: 7,
            contentVersion: 2,
        },
        // config.disciplinas — «Disciplinas» — roles: branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "config.disciplinas" — práctica: no
        "config.disciplinas": {
            summary: "Aprendés a cargar y editar disciplinas: el límite semanal, que la vuelve restringida y genera el derecho a recupero, y si admite fijaciones. Entendés por qué el precio del extra por clase no se carga en la disciplina sino en la lista de precios.",
            keyPoints: [
                "Cada actividad que se dicta es una disciplina: su configuración decide cuántas veces por semana puede ir un socio con su plan y si puede fijar su lugar.",
                "Pole, Kangoo y Bungee arrancan con límite de dos por semana; Yoga Aéreo y Reformer, de una. El resto no tiene límite.",
                "Una disciplina con límite semanal es siempre restringida: la casilla se marca sola y se bloquea.",
                "Ser restringida da derecho a recupero: si una clase no se dicta, por ejemplo por un feriado, el sistema le acredita al socio un crédito para recuperarla esa misma semana.",
                "Admite fijaciones permite que un socio tenga su lugar fijo en esa clase sin anotarse cada vez.",
                "El precio del extra, cuando un socio quiere ir más veces que su límite, no se carga en la disciplina: va en la lista de precios.",
            ],
            estimatedMin: 5,
            contentVersion: 2,
        },
        // config.acceso-dispositivos — «Puntos de acceso y dispositivos (molinetes y lectores)» — roles: branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "acceso.puntos" — práctica: no
        "config.acceso-dispositivos": {
            summary: "Recorrés Puntos de acceso (molinetes y QR de local agrupados por local, contingencia, regenerar el QR, huellas enroladas y parámetros) y la pantalla Dispositivos (alta de tablets y equipos de molinete con su clave de un solo uso, y revocación). Entendés por qué toda excepción pide motivo escrito y queda auditada.",
            keyPoints: [
                "Los puntos de acceso se agrupan por local, porque pertenecen al local y no a la sede. «Nunca reportó» no es lo mismo que «caído»: todavía no se pudo ver.",
                "Si se corta internet o el molinete no valida, se activa la contingencia con motivo: el paso queda liberado en todo el local y recepción registra los ingresos a mano. Al salir, el sistema revisa esos ingresos sin bloquear a nadie para atrás.",
                "Regenerar el QR del local hace que el cartel de la puerta deje de validar en el acto: hay que imprimir y colgar el nuevo.",
                "Forzar re-enrolamiento hace que ese dedo deje de abrir en el acto; la huella se vuelve a cargar en recepción y mientras tanto la persona entra con su QR o con habilitación manual.",
                "Los parámetros del acceso acá sólo se consultan: se editan en Configuración, Parámetros.",
                "La clave de un dispositivo se muestra una sola vez y no se recupera: si se pierde el equipo o la clave, se revoca y se da de alta de nuevo. Alta y revocación son del Dueño y Administración.",
            ],
            estimatedMin: 8,
            contentVersion: 2,
        },
        // config.cuentas-terminales — «Cuentas y terminales de cobro» — roles: branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "caja.configuracion" — práctica: no
        "config.cuentas-terminales": {
            summary: "Aprendés cómo se configuran las cuentas bancarias de la SRL que reciben transferencias (una sola visible al socio, con Interbanking para conciliar) y una terminal Payway por sede con su cuenta de acreditación y su tolerancia en días hábiles. Entendés por qué nadie tipea el importe en el posnet y por qué nada se borra.",
            keyPoints: [
                "Toda transferencia tiene que caer en una cuenta que el sistema pueda conciliar: una cuenta que Interbanking no ve, como un Mercado Pago personal, no puede recibir cobros.",
                "La cuenta marcada como visible al socio es la única que ve el socio en la app y en el mostrador. Si aparece el aviso de dos cuentas visibles, se corrige enseguida.",
                "Una cuenta que no llega por Interbanking se concilia a mano.",
                "Hay una terminal Payway por sede, con la cuenta donde acredita y su tolerancia: los días hábiles que tiene el banco para acreditar el lote.",
                "El cobro nace en el sistema y viaja al posnet: nadie tipea el importe en el posnet. Una sede sin terminal cargada no puede cobrar por posnet.",
                "Cuentas y terminales no se borran, se desactivan. Las cargan el Dueño y Administración; Encargados y Coordinación las ven en lectura.",
            ],
            estimatedMin: 6,
            contentVersion: 2,
        },
        // config.usuarios — «Usuarios y permisos» — roles: branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "roles.usuarios" — práctica: sí
        "config.usuarios": {
            summary: "Aprendés a administrar quién entra al sistema: un usuario por persona para siempre, con su rol, sus sedes, su PIN y el segundo factor; la rotación entre sedes sin crear otro usuario; y cómo desactivar, resetear la contraseña y cerrar sesiones a distancia. Entendés por qué un usuario compartido borra la trazabilidad.",
            keyPoints: [
                "Cada acción queda firmada con el usuario que la hizo: un usuario por persona, para siempre, nunca compartido. El email es la clave y no se repite.",
                "Al crear un usuario se eligen el rol y las sedes. El PIN, de cuatro a ocho números, sirve para fichar o autorizar excepciones en el molinete, y la persona lo puede cambiar después en Mi cuenta.",
                "El segundo factor por email se marca para el Dueño y Administración, porque ven la facturación de todo el club.",
                "La rotación se resuelve sumando la sede nueva al mismo usuario, sin sacar la vieja hasta que cierre su ciclo de caja.",
                "Desactivar pide motivo, corta en el acto el acceso al portal, a la tablet y a la app, y cierra todas las sesiones. El usuario no se borra: su historial queda.",
                "Resetear la contraseña pide motivo y la temporal se ve una sola vez. Los permisos vienen con el rol. Crean y cambian usuarios el Dueño y Administración; Encargados y Coordinación consultan.",
            ],
            estimatedMin: 9,
            contentVersion: 2,
        },
        // config.parametros — «Parámetros y catálogos» — roles: branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "config.parametros" — práctica: no
        "config.parametros": {
            summary: "Aprendés a leer y cambiar los parámetros, las reglas que el sistema aplica solo (tolerancia de deuda para entrar, gracia del apto médico, ventanas de reserva, penalidades por faltas), con su valor vigente, su origen y quién los edita. Entendés por qué un cambio se pone en vigencia como versión nueva con fecha e historial, y cómo se manejan los catálogos de opciones.",
            keyPoints: [
                "Cada parámetro muestra el valor que rige hoy y de dónde sale: valor por defecto, cargado global o cargado en la sede elegida.",
                "Lo general lo editan el Dueño y Coordinación; lo que mueve plata, el Dueño y Administración; los umbrales financieros, sólo el Dueño. El Encargado lo ve en lectura.",
                "Antes de cambiar, leé la explicación entera. Vigente desde puede ser una fecha futura o quedar vacío para que rija ya; en Nota va por qué cambia.",
                "Los importes se cargan en centavos: $ 1.500 se escribe 150000, y el sistema muestra a cuántos pesos equivale.",
                "Guardar no pisa nada: crea una versión nueva y la anterior queda en el Historial.",
                "Los catálogos son las opciones de las listas (categorías de gasto, orígenes de contacto, motivos de baja); lo que ya no se usa se desactiva, no se borra. Precios y promociones tienen su propia pantalla.",
            ],
            estimatedMin: 8,
            contentVersion: 2,
        },
        // config.integraciones — «Integraciones (Payway, ARCA, Mercado Pago, mail…)» — roles: admin (Administración), owner (Dueño) — pantalla: "config.integraciones" — práctica: no
        "config.integraciones": {
            summary: "Aprendés cómo el Dueño carga, prueba y revoca las credenciales de Payway, ARCA, Interbanking, Mercado Pago, molinetes, mail y avisos al celular, y cómo Administración ve el estado sin secretos. Entendés los estados, el plan B de cada integración, la vinculación de Mercado Pago sin tipear claves y por qué revocar no tiene vuelta atrás.",
            keyPoints: [
                "Las claves son la capacidad de cobrar y facturar a nombre del club: se cargan acá, quedan cifradas y sólo el Dueño carga, prueba y revoca. Administración ve el estado sin secretos; nadie más ve la sección.",
                "«Sin configurar» no es una falla: el sistema sigue con su plan B. «Incompleta» te dice qué falta, y «nunca se probó» no quiere decir que esté mal.",
                "Homologación es el ambiente de prueba del proveedor y producción mueve plata de verdad: las claves de uno no sirven en el otro.",
                "Un secreto guardado no se vuelve a mostrar, y un campo secreto que se guarda vacío quiere decir «no lo toqué». Después de cargar o cambiar algo, se toca Probar.",
                "Mercado Pago no se carga con claves: se vincula entrando con la cuenta del club. Cada CUIT de ARCA se gestiona en su emisor fiscal, con su certificado.",
                "Revocar pide motivo, apaga la integración y borra sus secretos sin forma de recuperarlos; el sistema pasa al plan B y queda registrado quién, cuándo y por qué.",
            ],
            estimatedMin: 10,
            contentVersion: 2,
        },
        // config.sistema — «Tareas automáticas y salud del sistema» — roles: intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "config.jobs" — práctica: no
        "config.sistema": {
            summary: "Recorrés Tareas automáticas (avisos, débitos, cierres, facturación) con su última y próxima corrida, el interruptor para apagarlas y el botón Correr ahora, y Salud del sistema: estado general, tareas atrasadas, comprobantes esperando a ARCA, molinetes en línea, proveedores y la prueba mensual de restauración de la copia. Entendés por qué «no se pudo ver» nunca es cero.",
            keyPoints: [
                "Cada tarea dice qué hace, cuándo corrió por última vez y cuándo vuelve a correr; si falló, muestra el último error. «No se pudo ver» no es «nunca corrió».",
                "Prenden y apagan tareas el Dueño y Coordinación: surte efecto en la próxima corrida, sin reiniciar nada, queda en la auditoría y no borra lo que la tarea ya hizo.",
                "«Correr ahora» lo tienen el Dueño y Administración: la tarea queda en cola y corre en la próxima pasada, sin esperar a su horario.",
                "El estado general es todo en orden, degradado o caído: degradado quiere decir que algo anda lento o con atraso, pero el negocio sigue operando.",
                "ARCA caído nunca frena un cobro: el comprobante se completa después.",
                "Todos los días se guarda una copia completa fuera del servidor y una vez por mes se prueba restaurarla; restaurar de verdad no tiene botón. Rojo o «no se pudo medir» repetido: avisá al Dueño.",
            ],
            estimatedMin: 6,
            contentVersion: 2,
        },
        // config.puesta-en-marcha — «Puesta en marcha: migración, checklist y encendido por sede» — roles: branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "migracion.checklist" — práctica: no
        "config.puesta-en-marcha": {
            summary: "Recorrés el pasaje del sistema viejo al nuevo: la migración de Crossfy con sus pruebas y comparaciones, el Checklist de arranque (lo que el sistema verifica solo y lo que marca una persona, las dos firmas por módulo y el corte que habilita sólo el Dueño) y el Encendido por sede, donde la caja no se escalona y acceso, reservas y kiosko se prenden de a una sede, empezando por Olivos.",
            keyPoints: [
                "El camino es: traer los datos, verificarlos, firmar que cada módulo está listo, hacer el corte y recién ahí encender cada sede.",
                "Antes del corte tiene que haber dos pruebas de migración completas y sin errores. Lo que no se pudo comparar aparece en rojo, nunca en verde, y una fila con problema se completa con Vero: no se inventa un dato.",
                "En el checklist, lo que se puede mirar contra la base se verifica solo; lo que no tiene chequeo automático lo marca una persona, y eso no quiere decir que falte.",
                "Cada módulo se aprueba con dos firmas, la del Dueño y la de Vero, y nadie firma por otro. El corte lo habilita sólo el Dueño, con el checklist completo.",
                "Primero va el último traspaso de datos y después se congelan Crossfy y Control Gym, que quedan sólo para consulta.",
                "La caja no se escalona: desde el corte, las tres sedes cobran en el sistema nuevo. Acceso, reservas por app y kiosko se prenden sede por sede, con motivo; nunca antes del corte, y apagar se puede siempre.",
            ],
            estimatedMin: 10,
            contentVersion: 2,
        },
        // config.seguimiento — «Seguimiento de la capacitación del equipo» — roles: branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "capacitacion.equipo" — práctica: no
        "config.seguimiento": {
            summary: "Aprendés a usar Seguimiento del equipo: los filtros por sede, rol y estado, los cuatro indicadores, una fila por persona con su detalle lección por lección y las preguntas que falló, las preguntas más falladas del equipo y Exportar CSV. Entendés por qué es para acompañar y no para controlar: el plazo no bloquea a nadie.",
            keyPoints: [
                "La usan el Dueño, Administración, Coordinación y los Encargados; el Encargado ve sólo a la gente de su sede activa. Recepción, Profesores y el Contador no tienen esta pantalla.",
                "Los estados son Sin empezar, En curso, Aprobó el final y Vencido (pasó el plazo sin aprobar el final). Si todavía no hay datos, dice «sin datos», no cero.",
                "En Personas hay una fila por persona con rol, sede, avance, lecciones completas, promedio, intentos, final, última actividad y estado; «nunca entró» quiere decir que nunca abrió el curso.",
                "El detalle de una persona muestra, lección por lección, si vio el video, si hizo la práctica, su nota y cada pregunta que falló: eso te dice qué repasar con ella.",
                "Si muchos fallan la misma pregunta, no es un problema de una persona: es un tema para repasar en grupo antes del arranque.",
                "Exportar CSV respeta los filtros y queda registrado. El plazo es informativo: no bloquea la caja, los cobros ni ninguna operación, y el sistema no manda recordatorios.",
            ],
            estimatedMin: 6,
            contentVersion: 2,
        },
    },
    questions: [
        // ── config.planes ─────────────────────────────────────────────────────────────
        {
            id: "config.planes#1",
            lessonKey: "config.planes",
            prompt: "En la tabla de planes, la celda del plan mensual en débito dice «no está en lista». Un socio quiere pagar ese plan con débito. ¿Qué significa?",
            options: [
                {
                    id: "a",
                    text: "Que con débito ese plan es gratis, porque no hay importe cargado para ese medio.",
                },
                { id: "b", text: "Que con débito no se puede cobrar ese plan: ese medio no tiene precio." },
                { id: "c", text: "Que el sistema cobra el precio de efectivo." },
                { id: "d", text: "Que recepción carga el importe a mano en el mostrador." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, «no está en lista» no significa gratis: ese medio no tiene precio cargado y con él no se puede cobrar ese plan. Ningún precio se inventa en el mostrador.",
        },
        {
            id: "config.planes#2",
            lessonKey: "config.planes",
            prompt: "El mes que viene sube la cuota. ¿Cómo se carga el aumento?",
            options: [
                { id: "a", text: "Editás el precio en la ficha de cada plan." },
                {
                    id: "b",
                    text: "Cambiás los importes de la lista vigente y guardás: así el aumento rige desde hoy mismo para todos.",
                },
                { id: "c", text: "Creás un plan nuevo con el precio nuevo y das de baja el viejo." },
                {
                    id: "d",
                    text: "Tocás Nueva versión en Lista de precios, con vigencia el día 1 del mes que viene, y publicás.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, el plan no tiene precios y la lista vigente no se toca: un aumento es una versión nueva de la lista, que arranca con los importes actuales y rige desde el día 1 de un mes.",
        },
        {
            id: "config.planes#3",
            lessonKey: "config.planes",
            prompt: "Publicaste la lista nueva y te das cuenta de que cargaste mal el precio de un plan. ¿Qué hacés?",
            options: [
                { id: "a", text: "Cargás otra versión: una lista publicada no se edita." },
                { id: "b", text: "Abrís la lista publicada, corregís el importe y la volvés a guardar." },
                { id: "c", text: "Borrás la lista publicada y la volvés a cargar." },
                { id: "d", text: "Le pedís a recepción que cobre a mano el precio correcto." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, el sistema frena a propósito la edición de una lista publicada: se corrige cargando otra versión. Así cada aumento queda registrado con su fecha y con quién lo cargó.",
        },
        {
            id: "config.planes#4",
            lessonKey: "config.planes",
            prompt: "El club deja de vender el plan trimestral, pero varios socios lo tienen vigente. ¿Qué pasa cuando lo das de baja?",
            options: [
                { id: "a", text: "Se borra y esas membresías se cortan en el acto." },
                { id: "b", text: "No se puede dar de baja hasta que venzan todas." },
                {
                    id: "c",
                    text: "Deja de venderse y las membresías vigentes siguen hasta su vencimiento.",
                },
                { id: "d", text: "Las membresías pasan solas al plan mensual." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, un plan no se borra: se da de baja, deja de venderse y las membresías vigentes siguen hasta su vencimiento.",
        },
        // ── config.promociones ────────────────────────────────────────────────────────
        {
            id: "config.promociones#1",
            lessonKey: "config.promociones",
            prompt: "Un socio le pide a la recepcionista un 15% de descuento porque trae a su hermano, pero no hay ninguna promo vigente así. ¿Qué puede hacer recepción?",
            options: [
                {
                    id: "a",
                    text: "Aplicar el 15% a mano y dejarlo anotado en observaciones para que lo revise el Dueño.",
                },
                { id: "b", text: "Crear la promo desde la pantalla de cobro." },
                { id: "c", text: "Sólo elegir una promo vigente: si no existe, no hay descuento." },
                { id: "d", text: "Cobrar menos y avisarle al Dueño a fin de mes." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, recepción no inventa descuentos: elige una promo vigente al cobrar. Así cada peso descontado tiene nombre, fecha y responsable.",
        },
        {
            id: "config.promociones#2",
            lessonKey: "config.promociones",
            prompt: "Hay que cortar ya una promo que se está aplicando mal. ¿Qué pasa al desactivarla?",
            options: [
                {
                    id: "a",
                    text: "Pide motivo escrito, deja de aplicarse en el acto y los pagos que la usaron le siguen apuntando.",
                },
                {
                    id: "b",
                    text: "Se borra junto con los pagos que la usaron, para que no quede ningún rastro de la promo mal aplicada.",
                },
                { id: "c", text: "Recepción la puede seguir aplicando hasta su fecha de Vigente hasta." },
                { id: "d", text: "Se desactiva sin pedir nada y se pierde su historial de uso." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, desactivar exige un motivo y no borra: la promo deja de aplicarse en el acto, pero los pagos que la usaron le siguen apuntando.",
        },
        {
            id: "config.promociones#3",
            lessonKey: "config.promociones",
            prompt: "La promo «Traé un amigo» da 20% y ya se aplicó en varios pagos. Ahora querés que sea 25%. ¿Qué hacés?",
            options: [
                { id: "a", text: "Editás el valor y guardás." },
                {
                    id: "b",
                    text: "La borrás y la volvés a crear con 25%, así los pagos anteriores quedan con el valor nuevo.",
                },
                { id: "c", text: "Pedís que se reviertan los pagos que la usaron." },
                { id: "d", text: "Creás otra promoción: el tipo y el valor no se editan." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, al editar una promo ya creada el tipo y el valor quedan bloqueados, porque los pagos le apuntan. Para otro descuento se crea otra promoción.",
        },
        {
            id: "config.promociones#4",
            lessonKey: "config.promociones",
            prompt: "Recepción aplicó una promo 11 veces, pero uno de esos pagos se revirtió. El reporte de uso muestra 10. ¿Está bien?",
            options: [
                { id: "a", text: "No: debería mostrar 11, porque se aplicó 11 veces." },
                {
                    id: "b",
                    text: "Sí: el uso sale de los cobros reales y un pago revertido no cuenta como uso.",
                },
                { id: "c", text: "No: el reporte sólo cuenta las promos desactivadas." },
                { id: "d", text: "Depende de qué sede la aplicó." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, el reporte de uso sale de los cobros reales: un pago revertido no cuenta como uso.",
        },
        // ── config.textos-legales ─────────────────────────────────────────────────────
        {
            id: "config.textos-legales#1",
            lessonKey: "config.textos-legales",
            prompt: "Un socio reclama por una regla del reglamento que cambió el mes pasado; él firmó hace un año. ¿Qué te puede mostrar el sistema?",
            options: [
                {
                    id: "a",
                    text: "Que firmó la versión actual, porque publicar actualiza todas las firmas anteriores.",
                },
                { id: "b", text: "La versión que firmó y cuándo: las firmas viejas no se tocan." },
                { id: "c", text: "Nada: al publicar, las firmas viejas se descartan." },
                { id: "d", text: "Sólo la fecha de la firma, sin el texto." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, cada firma guarda su versión, la fecha, quién firmó y el medio, y con Ver el texto leés exactamente lo que se firmó. Por eso, si alguien reclama, se puede mostrar qué firmó y cuándo.",
        },
        {
            id: "config.textos-legales#2",
            lessonKey: "config.textos-legales",
            prompt: "Cambiaste algo importante del reglamento y activás «Pedir re-aceptación en el próximo uso». ¿Qué pasa con los socios?",
            options: [
                {
                    id: "a",
                    text: "El molinete no los deja entrar hasta que acepten la versión nueva en la app.",
                },
                { id: "b", text: "Se anulan sus firmas anteriores." },
                { id: "c", text: "Recepción tiene que llamar a cada uno." },
                { id: "d", text: "La app se la pide, pero no les bloquea el ingreso." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, la re-aceptación se pide en la app pero no bloquea el ingreso: el socio sigue entrando mientras tanto.",
        },
        {
            id: "config.textos-legales#3",
            lessonKey: "config.textos-legales",
            prompt: "La tarjeta de Cesión de imagen dice «Sin versiones». ¿Qué implica?",
            options: [
                { id: "a", text: "Que todavía no se puede mandar a firmar." },
                { id: "b", text: "Que los socios no necesitan firmarlo hasta que el Dueño lo active." },
                { id: "c", text: "Que se firma con el texto del reglamento." },
                { id: "d", text: "Que hay que pedir re-aceptación a todos." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, si una tarjeta dice «Sin versiones», ese documento todavía no se puede mandar a firmar. Primero se le publica la primera versión.",
        },
        {
            id: "config.textos-legales#4",
            lessonKey: "config.textos-legales",
            prompt: "Una recepcionista quiere corregir un error de tipeo en el reglamento y ve el botón Publicar versión deshabilitado. ¿Por qué?",
            options: [
                { id: "a", text: "Porque un texto vigente no admite cambios durante un año." },
                { id: "b", text: "Porque antes hay que pedir re-aceptación." },
                { id: "c", text: "Porque publicar lo hacen sólo el Dueño y Administración." },
                { id: "d", text: "Porque hay un socio firmando en ese momento." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, publicar lo hacen el Dueño y Administración: si no sos ninguno de los dos, el botón aparece deshabilitado.",
        },
        // ── config.sedes-salones ──────────────────────────────────────────────────────
        {
            id: "config.sedes-salones#1",
            lessonKey: "config.sedes-salones",
            prompt: "Se cobra una cuota en la caja de Olivos y se dicta una clase de Reformer en uno de sus locales. ¿A qué se imputa cada cosa?",
            options: [
                { id: "a", text: "Las dos a la sede." },
                { id: "b", text: "Las dos al local." },
                { id: "c", text: "El cobro a la sede y la clase al local." },
                { id: "d", text: "El cobro a la sede Central y la clase a la sede." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, la plata y el stock van a la sede, y las clases y los molinetes al local. Entender esa diferencia evita la mitad de las dudas del día a día.",
        },
        {
            id: "config.sedes-salones#2",
            lessonKey: "config.sedes-salones",
            prompt: "Alguien propone asignarle una recepción y socios a la sede Central. ¿Por qué no corresponde?",
            options: [
                { id: "a", text: "Porque Central es virtual: no tiene locales ni opera." },
                {
                    id: "b",
                    text: "Porque Central sólo se usa para facturar los cobros de las tres sedes juntas.",
                },
                { id: "c", text: "Porque Central es la sede personal del Dueño." },
                { id: "d", text: "Porque Central ya tiene su propio local con recepción." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, la sede Central es virtual: no tiene locales ni opera. Junta los gastos comunes del club para repartirlos después entre las sedes.",
        },
        {
            id: "config.sedes-salones#3",
            lessonKey: "config.sedes-salones",
            prompt: "Un salón tiene capacidad 8 para Reformer. Coordinación quiere abrir ahí una clase de Reformer con 12 lugares. ¿Qué pasa?",
            options: [
                {
                    id: "a",
                    text: "Se puede: la capacidad del salón es orientativa y la clase define su propio cupo.",
                },
                { id: "b", text: "Se puede si la clase es en otro horario." },
                { id: "c", text: "Se toma la capacidad de otra disciplina del mismo salón." },
                { id: "d", text: "No puede pasar de 8: es el techo del cupo." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, cada salón tiene su capacidad por disciplina y ese número es el techo del cupo de cada clase.",
        },
        {
            id: "config.sedes-salones#4",
            lessonKey: "config.sedes-salones",
            prompt: "Se despegó y rompió el cartel con el QR de un salón. ¿Qué hacés?",
            options: [
                {
                    id: "a",
                    text: "Regenerás el QR del salón para que el cartel viejo deje de servir y colgás el nuevo.",
                },
                { id: "b", text: "Lo reimprimís con Hoja imprimible del QR: ese QR no cambia." },
                { id: "c", text: "Activás la contingencia del local." },
                {
                    id: "d",
                    text: "Les decís a los socios que avisen el presente en recepción hasta que haya cartel nuevo.",
                },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, el QR del salón nace con la sala y no se regenera: se reimprime desde Hoja imprimible del QR. Lo que se regenera es el QR del local, desde Puntos de acceso.",
        },
        // ── config.disciplinas ────────────────────────────────────────────────────────
        {
            id: "config.disciplinas#1",
            lessonKey: "config.disciplinas",
            prompt: "Cargás la disciplina Acro Prueba con límite semanal de dos y querés dejarla sin restringir. ¿Qué pasa?",
            options: [
                { id: "a", text: "No lo acepta: con límite, siempre es restringida." },
                {
                    id: "b",
                    text: "Se guarda sin restringir, como la dejaste, y el límite sigue valiendo igual.",
                },
                { id: "c", text: "El límite semanal se borra solo." },
                { id: "d", text: "Queda restringida sólo en la sede donde la cargaste." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, al poner un límite semanal la casilla Restringida se marca sola y se bloquea: una disciplina con límite siempre es restringida.",
        },
        {
            id: "config.disciplinas#2",
            lessonKey: "config.disciplinas",
            prompt: "El lunes es feriado y no se dicta la clase de Pole, que tiene límite de dos por semana. ¿Qué pasa con los socios anotados?",
            options: [
                { id: "a", text: "Pierden esa clase de la semana." },
                { id: "b", text: "Recepción les devuelve la parte proporcional de la cuota de ese mes." },
                { id: "c", text: "Reciben un crédito para recuperarla esa misma semana." },
                { id: "d", text: "Se les suma una clase extra al mes siguiente." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, ser restringida es lo que da derecho a recupero: si una clase no se dicta, por ejemplo por un feriado, el sistema acredita un crédito para recuperarla esa misma semana.",
        },
        {
            id: "config.disciplinas#3",
            lessonKey: "config.disciplinas",
            prompt: "Una socia quiere ir a Reformer dos veces por semana, pero su límite es una. ¿Dónde se define cuánto paga por la clase extra?",
            options: [
                { id: "a", text: "En la configuración de la disciplina Reformer." },
                { id: "b", text: "En la ficha de su plan." },
                { id: "c", text: "Lo decide recepción en el momento." },
                { id: "d", text: "En la lista de precios." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, el precio del extra, cuando un socio quiere ir más veces que su límite, no se carga en la disciplina: va en la lista de precios.",
        },
        {
            id: "config.disciplinas#4",
            lessonKey: "config.disciplinas",
            prompt: "Una socia va todos los martes a las 19 a Yoga Aéreo y quiere dejar de anotarse cada semana. ¿Qué configuración de la disciplina lo permite?",
            options: [
                { id: "a", text: "El límite semanal." },
                {
                    id: "b",
                    text: "Admite fijaciones: le da un lugar fijo en esa clase sin anotarse cada vez.",
                },
                { id: "c", text: "La casilla Restringida." },
                { id: "d", text: "Ninguna: eso se resuelve cambiándole el plan." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, Admite fijaciones permite que un socio tenga su lugar fijo en esa clase sin anotarse cada vez. Si no corresponde, se desmarca.",
        },
        // ── config.acceso-dispositivos ────────────────────────────────────────────────
        {
            id: "config.acceso-dispositivos#1",
            lessonKey: "config.acceso-dispositivos",
            prompt: "Se cortó internet en el local de Olivos y el molinete dejó de validar. ¿Qué hacés?",
            options: [
                {
                    id: "a",
                    text: "Dejás pasar a la gente sin registrar nada hasta que vuelva internet, para no armar fila en la puerta.",
                },
                {
                    id: "b",
                    text: "Activás la contingencia con motivo: se libera el paso y recepción anota los ingresos.",
                },
                { id: "c", text: "Regenerás el QR del local." },
                { id: "d", text: "Revocás el equipo del molinete y lo das de alta de nuevo." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, ante un corte de internet o un molinete que no valida se activa la contingencia, con motivo. Al salir, el sistema revisa esos ingresos y avisa cuáles habrían sido rechazados, sin bloquear a nadie para atrás.",
        },
        {
            id: "config.acceso-dispositivos#2",
            lessonKey: "config.acceso-dispositivos",
            prompt: "Circula por fotos el QR impreso de un local, así que lo regenerás con su motivo. ¿Qué tenés que hacer enseguida?",
            options: [
                {
                    id: "a",
                    text: "Nada urgente: el cartel viejo sigue sirviendo hasta fin de mes, así que lo cambiás con tiempo.",
                },
                { id: "b", text: "Avisarles a los socios que entren sólo con huella." },
                { id: "c", text: "Activar la contingencia del local." },
                { id: "d", text: "Imprimir y colgar el nuevo: el viejo deja de validar ya." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, al regenerar el QR el cartel de la puerta deja de validar en el acto: imprimí y colgá el nuevo antes de que llegue el próximo socio.",
        },
        {
            id: "config.acceso-dispositivos#3",
            lessonKey: "config.acceso-dispositivos",
            prompt: "Diste de alta una tablet nueva y tocaste «Ya la guardé» sin copiar la clave. ¿Cómo la recuperás?",
            options: [
                { id: "a", text: "No se recupera: revocás la tablet y la das de alta de nuevo." },
                {
                    id: "b",
                    text: "Se la pedís a Administración, que tiene guardadas las claves de todos los equipos.",
                },
                { id: "c", text: "La buscás en la auditoría." },
                { id: "d", text: "Regenerás el QR del local y la clave vuelve a aparecer." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, la clave del equipo se muestra una sola vez y no se puede recuperar. Si la perdiste, el camino es revocar y dar de alta.",
        },
        {
            id: "config.acceso-dispositivos#4",
            lessonKey: "config.acceso-dispositivos",
            prompt: "En la lista de dispositivos de un local, uno figura «nunca reportó». ¿Qué significa?",
            options: [
                { id: "a", text: "Que está caído." },
                { id: "b", text: "Que fue revocado." },
                { id: "c", text: "Que todavía no se pudo ver su estado: no es lo mismo que caído." },
                { id: "d", text: "Que el local está en contingencia." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, «nunca reportó» no es lo mismo que «caído»: es que todavía no se pudo ver.",
        },
        // ── config.cuentas-terminales ─────────────────────────────────────────────────
        {
            id: "config.cuentas-terminales#1",
            lessonKey: "config.cuentas-terminales",
            prompt: "Un encargado propone que los socios transfieran a su Mercado Pago personal porque es más rápido. ¿Por qué no se puede?",
            options: [
                {
                    id: "a",
                    text: "Porque Mercado Pago cobra comisión por cada transferencia que recibe el club.",
                },
                { id: "b", text: "Porque sólo se aceptan transferencias de un banco." },
                { id: "c", text: "Porque Interbanking no ve esa cuenta y no se podría conciliar." },
                { id: "d", text: "Porque el socio tiene que tener cuenta en el mismo banco." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, toda transferencia tiene que caer en una cuenta que el sistema pueda conciliar. Una cuenta que Interbanking no ve, como un Mercado Pago personal, no puede recibir cobros.",
        },
        {
            id: "config.cuentas-terminales#2",
            lessonKey: "config.cuentas-terminales",
            prompt: "Aparece el aviso de que hay dos cuentas visibles al socio. ¿Por qué hay que corregirlo enseguida?",
            options: [
                { id: "a", text: "Porque la app las mostraría todas, y debe mostrar una sola." },
                { id: "b", text: "Porque se bloquean todas las transferencias." },
                {
                    id: "c",
                    text: "Porque el sistema borra sola una de las dos y se pierden sus movimientos.",
                },
                { id: "d", text: "Porque la terminal Payway deja de funcionar." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, la cuenta visible al socio es la única que ve en la app y en el mostrador. Con dos marcadas, la app las va a mostrar todas: hay que corregirlo ya.",
        },
        {
            id: "config.cuentas-terminales#3",
            lessonKey: "config.cuentas-terminales",
            prompt: "Cargás la terminal Payway de una sede que acredita en ICBC y ponés tolerancia tres. ¿Qué representa ese número?",
            options: [
                { id: "a", text: "Las cuotas sin interés que acepta la terminal." },
                { id: "b", text: "Cuántos posnet tiene la sede." },
                { id: "c", text: "Los minutos que espera el posnet antes de cancelar un cobro." },
                { id: "d", text: "Los días hábiles que tiene el banco para acreditar el lote." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, la tolerancia son los días hábiles que tiene el banco para acreditar el lote: por ejemplo, uno en Francés y tres en ICBC.",
        },
        {
            id: "config.cuentas-terminales#4",
            lessonKey: "config.cuentas-terminales",
            prompt: "Un socio paga con tarjeta en el posnet. ¿Cómo llega el importe a la terminal?",
            options: [
                { id: "a", text: "Recepción lo tipea en el posnet." },
                { id: "b", text: "El cobro nace en el sistema y viaja al posnet: nadie tipea el importe." },
                { id: "c", text: "El socio lo tipea en el posnet." },
                { id: "d", text: "Payway lo calcula con la lista de precios." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, el cobro nace en el sistema y viaja al posnet: nadie tipea el importe en el posnet.",
        },
        // ── config.usuarios ───────────────────────────────────────────────────────────
        {
            id: "config.usuarios#1",
            lessonKey: "config.usuarios",
            prompt: "En recepción proponen crear un usuario «recepcion.olivos» para que lo use todo el turno. ¿Por qué no se hace?",
            options: [
                {
                    id: "a",
                    text: "Porque el sistema cobra por usuario y conviene tener la menor cantidad posible de cuentas.",
                },
                { id: "b", text: "Porque los usuarios de recepción no pueden tener PIN." },
                { id: "c", text: "Porque sólo el Dueño puede tener un usuario genérico." },
                { id: "d", text: "Porque un usuario compartido borra la trazabilidad de cada acción." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, la regla es una sola: un usuario por persona, para siempre, y nunca uno compartido. Un usuario compartido borra la trazabilidad, que es lo que el sistema cuida.",
        },
        {
            id: "config.usuarios#2",
            lessonKey: "config.usuarios",
            prompt: "Juana Prueba trabaja en recepción de Olivos y la pasan a otra sede. ¿Cómo se resuelve?",
            options: [
                {
                    id: "a",
                    text: "Le creás un usuario nuevo con otro email para la sede nueva, así cada sede tiene el suyo.",
                },
                {
                    id: "b",
                    text: "Le sumás la sede nueva y le quitás Olivos cuando cierre su ciclo de caja.",
                },
                { id: "c", text: "La desactivás y le creás otro usuario." },
                { id: "d", text: "Le sacás Olivos en el acto y le ponés la sede nueva." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, rotar no es crear otro usuario: se le cambian las sedes. La vieja se le quita recién cuando cierra su ciclo de caja.",
        },
        {
            id: "config.usuarios#3",
            lessonKey: "config.usuarios",
            prompt: "Una recepcionista deja de trabajar hoy en el club y tenía la sesión abierta en la tablet. ¿Qué pasa al desactivarla con su motivo?",
            options: [
                { id: "a", text: "Pierde el acceso en el acto en todas partes y su historial queda." },
                { id: "b", text: "Se borra el usuario junto con su historial." },
                { id: "c", text: "Sigue pudiendo entrar hasta fin de mes." },
                {
                    id: "d",
                    text: "Se le corta sólo el portal; la tablet sigue abierta hasta que alguien cierre la sesión.",
                },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, desactivar corta el acceso al instante en todas partes y cierra las sesiones. No se borra: su nombre y su historial quedan en la auditoría.",
        },
        {
            id: "config.usuarios#4",
            lessonKey: "config.usuarios",
            prompt: "Alguien olvidó su contraseña y le tocás Resetear contraseña con su motivo. ¿Qué tenés que tener en cuenta?",
            options: [
                { id: "a", text: "Que la temporal le llega sola por mail." },
                { id: "b", text: "Que la persona pierde su historial." },
                { id: "c", text: "Que la temporal se muestra una sola vez: pasásela por un canal seguro." },
                { id: "d", text: "Que también se le cambia el rol." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, el sistema genera una contraseña temporal que se muestra una sola vez, y se la tenés que pasar por un canal seguro.",
        },
        // ── config.parametros ─────────────────────────────────────────────────────────
        {
            id: "config.parametros#1",
            lessonKey: "config.parametros",
            prompt: "Tenés que cargar en un parámetro un importe de $ 1.500. ¿Qué escribís?",
            options: [
                { id: "a", text: "1500, tal como se lee el importe en pesos." },
                { id: "b", text: "150000" },
                { id: "c", text: "1.500,00, con los centavos después de la coma." },
                { id: "d", text: "15, porque el sistema agrega los ceros solo." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, los importes se cargan en centavos: mil quinientos pesos se escriben ciento cincuenta mil. Abajo del campo el sistema te muestra a cuántos pesos equivale.",
        },
        {
            id: "config.parametros#2",
            lessonKey: "config.parametros",
            prompt: "Un socio reclama que en agosto lo dejaron entrar con deuda y hoy no. La tolerancia se cambió en septiembre. ¿Cómo sabés qué regía en agosto?",
            options: [
                {
                    id: "a",
                    text: "No se puede saber: el cambio de septiembre pisó el valor anterior y quedó sólo el nuevo.",
                },
                { id: "b", text: "Le preguntás a Coordinación si se acuerda." },
                { id: "c", text: "Lo deducís de los ingresos del molinete." },
                { id: "d", text: "Mirás el Historial del parámetro: la versión anterior quedó guardada." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, guardar no pisa nada: crea una versión nueva y la anterior queda en el Historial. Así podés responder qué tolerancia regía en agosto.",
        },
        {
            id: "config.parametros#3",
            lessonKey: "config.parametros",
            prompt: "El motivo de baja «Mudanza al exterior» ya no se usa. ¿Qué hacés en Catálogos?",
            options: [
                { id: "a", text: "Lo desactivás, para que lo cargado antes conserve su motivo." },
                { id: "b", text: "Lo borrás para que no aparezca más." },
                { id: "c", text: "Le cambiás la etiqueta por otro motivo." },
                { id: "d", text: "Lo dejás activo para no perder nada." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, un motivo que ya no se usa no se borra: lo desactivás, para que lo cargado antes conserve su motivo.",
        },
        {
            id: "config.parametros#4",
            lessonKey: "config.parametros",
            prompt: "Sos Encargado y querés cambiar la gracia del apto médico, pero la fila aparece bloqueada. ¿Qué significa?",
            options: [
                {
                    id: "a",
                    text: "Que hay un error en el sistema y hay que avisarle a Coordinación para que lo destrabe.",
                },
                { id: "b", text: "Que el parámetro tiene una versión futura cargada." },
                { id: "c", text: "Que no es de tu rol: lo ves, pero lo edita otro." },
                { id: "d", text: "Que se cambia desde Planes y precios." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, si un parámetro no es de tu rol lo ves bloqueado y te dice quién lo edita. El Encargado consulta los parámetros en lectura.",
        },
        // ── config.integraciones ──────────────────────────────────────────────────────
        {
            id: "config.integraciones#1",
            lessonKey: "config.integraciones",
            prompt: "En Integraciones, Payway figura «Sin configurar». ¿Qué significa para el club?",
            options: [
                {
                    id: "a",
                    text: "Que no se puede cobrar con tarjeta de ninguna forma hasta que alguien cargue las claves.",
                },
                { id: "b", text: "Que hay una falla grave y hay que frenar la caja." },
                { id: "c", text: "No es una falla: el sistema sigue con su plan B." },
                { id: "d", text: "Que Administración tiene que cargar las claves." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, «sin configurar» no es una falla: el sistema sigue andando con su plan B, y cada integración dice cuál es. Si Payway no anda, se cobra con cupón manual. El club no se frena.",
        },
        {
            id: "config.integraciones#2",
            lessonKey: "config.integraciones",
            prompt: "Editás una integración para cambiar un dato y dejás vacío el campo secreto. ¿Qué pasa al guardar?",
            options: [
                { id: "a", text: "El secreto no se borra: vacío significa que no lo tocaste." },
                { id: "b", text: "Se borra el secreto guardado." },
                { id: "c", text: "El sistema no te deja guardar." },
                { id: "d", text: "Se vuelve a mostrar el secreto para que lo copies." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, una vez guardado el secreto no se vuelve a mostrar, y si dejás un campo secreto vacío al guardar no se borra: significa que no lo tocaste.",
        },
        {
            id: "config.integraciones#3",
            lessonKey: "config.integraciones",
            prompt: "Sospechás que se filtró la clave de una integración y la revocás. ¿Qué pasa?",
            options: [
                {
                    id: "a",
                    text: "Se oculta por un tiempo y después se puede recuperar desde la auditoría con tu usuario.",
                },
                { id: "b", text: "Queda en pausa hasta el día siguiente." },
                { id: "c", text: "No cambia nada hasta que alguien toque Probar." },
                { id: "d", text: "Se apaga, se borran sus secretos para siempre y pasa al plan B." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, revocar pide motivo y no tiene vuelta atrás: se borran los secretos y hay que pedírselos de nuevo al proveedor. Mientras tanto, el sistema sigue con el plan B.",
        },
        {
            id: "config.integraciones#4",
            lessonKey: "config.integraciones",
            prompt: "Vas a conectar la cuenta de Mercado Pago del club. ¿Cómo se hace?",
            options: [
                {
                    id: "a",
                    text: "Pegás el usuario y la contraseña de Mercado Pago del club en el formulario y guardás.",
                },
                { id: "b", text: "Tocás Vincular y autorizás desde Mercado Pago con la cuenta del club." },
                { id: "c", text: "Le mandás la clave a Administración para que la cargue." },
                { id: "d", text: "Dejás la clave escrita en Notas." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, Mercado Pago no se carga con claves: se vincula y se autoriza desde Mercado Pago, y el sistema nunca ve tu contraseña. En Notas nunca va una clave.",
        },
        // ── config.sistema ────────────────────────────────────────────────────────────
        {
            id: "config.sistema#1",
            lessonKey: "config.sistema",
            prompt: "Un aviso automático les está llegando de más a los socios. Sos Coordinación. ¿Qué hacés?",
            options: [
                { id: "a", text: "Apagás la tarea con su interruptor." },
                { id: "b", text: "Pedís que reinicien el sistema." },
                {
                    id: "c",
                    text: "Tocás Correr ahora para que termine más rápido y deje de mandar avisos.",
                },
                { id: "d", text: "Borrás la tarea." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, si una tarea hace algo que no querés la apagás con su interruptor. Prenden y apagan el Dueño y Coordinación, y apagar no borra nada de lo que ya hizo.",
        },
        {
            id: "config.sistema#2",
            lessonKey: "config.sistema",
            prompt: "Una tarea dice «no se pudo ver» en su última corrida. ¿Qué significa?",
            options: [
                { id: "a", text: "Que nunca corrió desde que se instaló el sistema y hay que prenderla." },
                { id: "b", text: "Que corrió y no hizo nada." },
                { id: "c", text: "Que en ese momento el sistema no lo pudo consultar." },
                { id: "d", text: "Que alguien la apagó." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, «no se pudo ver» no significa que nunca corrió: el sistema no lo pudo consultar en ese momento. No es un cero; si se repite, es algo para mirar.",
        },
        {
            id: "config.sistema#3",
            lessonKey: "config.sistema",
            prompt: "Salud del sistema muestra el estado general «degradado». ¿Qué quiere decir?",
            options: [
                { id: "a", text: "Que el sistema está caído." },
                { id: "b", text: "Que hay que cerrar las cajas." },
                { id: "c", text: "Que hay que restaurar la copia de seguridad." },
                { id: "d", text: "Que algo anda lento o con atraso, pero el negocio sigue operando." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, degradado quiere decir que algo anda lento o con atraso, pero el negocio sigue operando. No es lo mismo que caído.",
        },
        {
            id: "config.sistema#4",
            lessonKey: "config.sistema",
            prompt: "ARCA no responde y hay un socio esperando para pagar en recepción. ¿Qué pasa con el cobro?",
            options: [
                {
                    id: "a",
                    text: "Hay que esperar a que ARCA vuelva, porque sin comprobante no se puede cobrar.",
                },
                { id: "b", text: "Se cobra igual y el comprobante se completa después." },
                { id: "c", text: "Se cobra sin dejar registro en el sistema." },
                { id: "d", text: "Se cobra sólo en efectivo." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, ARCA caído nunca frena un cobro: el comprobante se completa después.",
        },
        // ── config.puesta-en-marcha ───────────────────────────────────────────────────
        {
            id: "config.puesta-en-marcha#1",
            lessonKey: "config.puesta-en-marcha",
            prompt: "En una corrida de migración, una comparación contra las planillas de contraste no se pudo hacer. ¿Cómo aparece?",
            options: [
                { id: "a", text: "En verde, porque no se encontraron diferencias contra las planillas." },
                { id: "b", text: "En rojo, nunca en verde." },
                { id: "c", text: "No aparece en la corrida." },
                { id: "d", text: "En gris, y se puede ignorar." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, si una comparación no se pudo hacer aparece en rojo, nunca en verde. Y una fila con problema queda archivada para completarla con Vero: no se inventa un dato.",
        },
        {
            id: "config.puesta-en-marcha#2",
            lessonKey: "config.puesta-en-marcha",
            prompt: "El Dueño está de viaje y Administración propone firmar por él el módulo de caja para no demorar el arranque. ¿Qué corresponde?",
            options: [
                {
                    id: "a",
                    text: "Puede firmar cualquiera de Administración en nombre del Dueño si está de viaje.",
                },
                { id: "b", text: "Con la firma de Vero sola alcanza." },
                { id: "c", text: "Nadie firma por otro: hacen falta el Dueño y Vero." },
                { id: "d", text: "Se puede firmar después del corte." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, cada módulo se aprueba con dos firmas por separado, la del Dueño y la de Vero. Recién con las dos queda aprobado, y nadie firma por otro.",
        },
        {
            id: "config.puesta-en-marcha#3",
            lessonKey: "config.puesta-en-marcha",
            prompt: "¿Por qué hay que hacer el último traspaso de datos antes de congelar Crossfy y Control Gym?",
            options: [
                { id: "a", text: "Porque se perdería lo que se movió la última noche." },
                { id: "b", text: "Porque congelar borra los datos de Crossfy." },
                {
                    id: "c",
                    text: "Porque el último traspaso sólo funciona con Crossfy y Control Gym ya congelados.",
                },
                { id: "d", text: "Da igual el orden: los dos pasos son independientes." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, el orden importa: congelar antes del último traspaso perdería lo que se movió la última noche.",
        },
        {
            id: "config.puesta-en-marcha#4",
            lessonKey: "config.puesta-en-marcha",
            prompt: "Ya pasó el corte. Olivos tiene el acceso prendido, pero otra sede todavía está apagada. Un socio de esa sede quiere pagar su cuota y entrar. ¿Qué pasa?",
            options: [
                { id: "a", text: "Se le cobra en Crossfy, porque su sede no se prendió." },
                { id: "b", text: "No se le puede cobrar hasta que se prenda su sede." },
                {
                    id: "c",
                    text: "En el sistema nuevo, y el molinete de su sede decide solo si lo deja entrar.",
                },
                { id: "d", text: "En el sistema nuevo, y recepción controla su ingreso en pantalla." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, la caja no se escalona: desde el corte, las tres sedes cobran en el sistema nuevo. Mientras una sede esté apagada, recepción controla el ingreso mirando el estado del socio en pantalla.",
        },
        // ── config.seguimiento ────────────────────────────────────────────────────────
        {
            id: "config.seguimiento#1",
            lessonKey: "config.seguimiento",
            prompt: "Sos Encargado de Olivos y querés ver cómo viene la gente de otra sede. ¿Qué pasa?",
            options: [
                { id: "a", text: "Cambiás el filtro de sede de arriba y ves al equipo de esa sede." },
                { id: "b", text: "Exportás el CSV de todas las sedes." },
                { id: "c", text: "No podés: ves sólo tu sede activa." },
                { id: "d", text: "La ves en lectura, sin el detalle." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, Dueño, Administración y Coordinación ven todas las sedes; el Encargado ve sólo a la gente de su sede activa y el filtro de sede viene fijo.",
        },
        {
            id: "config.seguimiento#2",
            lessonKey: "config.seguimiento",
            prompt: "En el detalle de Juana Prueba ves que falló las preguntas de cierre de caja. ¿Qué es lo más útil que podés hacer?",
            options: [
                { id: "a", text: "Sentarte un rato con ella a hacer un cierre juntos." },
                { id: "b", text: "Sacarle la caja hasta que apruebe." },
                { id: "c", text: "Anotarlo como evaluación de desempeño." },
                { id: "d", text: "Esperar a que el sistema le mande un recordatorio." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, lo que falló dice qué repasar: si falló las de cierre de caja, sentate un rato a hacer un cierre juntos. La pantalla es para acompañar, no para evaluar desempeño.",
        },
        {
            id: "config.seguimiento#3",
            lessonKey: "config.seguimiento",
            prompt: "En Preguntas más falladas, la misma pregunta la falla la mitad del equipo. ¿Cómo lo leés?",
            options: [
                { id: "a", text: "Es un problema de cada persona que la falló." },
                { id: "b", text: "La pregunta está mal y hay que ignorarla." },
                { id: "c", text: "Hay que frenar el arranque hasta que todos la aprueben." },
                { id: "d", text: "Es un tema para repasar en grupo antes del arranque." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, si muchos fallan la misma pregunta no es un problema de una persona: es un tema para repasar en grupo antes del arranque.",
        },
        {
            id: "config.seguimiento#4",
            lessonKey: "config.seguimiento",
            prompt: "Una persona pasó el plazo sin aprobar el examen final y figura «Vencido». ¿Qué pasa?",
            options: [
                { id: "a", text: "Se le bloquea la caja hasta que apruebe el examen final." },
                { id: "b", text: "Nada se bloquea: el plazo es informativo." },
                { id: "c", text: "El sistema le manda un recordatorio todos los días." },
                { id: "d", text: "Se le desactiva el usuario." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, el plazo es informativo: no bloquea la caja, los cobros ni ninguna operación, y el sistema no manda recordatorios. Avisarle a alguien depende de vos.",
        },
    ],
};
//# sourceMappingURL=configuracion.js.map